<template>
  <div>
    <span
      class="pending-icon nav-link-item"
      @click="goToEntityList"
    >
      <a-badge
        :count="taskNumber"
        :offset="[20,6]"
      >
        <div class="pending-icon-content">
          <Bell :size="14" />
          <span class="pending-icon-text">{{ $t("k_3e0857e6") }}</span>
        </div>
      </a-badge>
    </span>
  </div>
</template>

<script>
import { getAppParams } from '@utils/path';
import { Bell } from 'lucide-vue';
export default {
  components: {
    Bell,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    taskNumber: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    urlParams() {
      return getAppParams() || {};
    },
    projectId() {
      return this.urlParams.projectId;
    },
    env() {
      return this.urlParams.env;
    },
  },
  methods: {
    goToEntityList() {
      const branch = getAppParams('branch');
      const router = this.$router.resolve({ name: 'workflow.entity-list', query: { menu: 'pending', branch } });
      window.open(router.href, '_blank');
    },
  },
};
</script>

<style lang="scss" scoped>
.pending-icon {
  color: rgba(0, 0, 0, 0.9);
  display: flex;
  &:hover {
    background: var(--wuji-primary-bg-color);
    cursor: pointer;
  }
}
.pending-icon-content {
  display: flex;
  align-items: center;
  gap: 8px;
  .pending-icon-text {
    line-height: 1.5;
  }
}
.router-link-active {
  color: var(--wuji-primary-color);
}
</style>
